import React from 'react';
import Modal from '@ignitesales/neuro-application/src/neuro-ui/lib/Modal/Modal';
import {buildHubspotEmailUrl} from "../utils/hubspot/buildHubspotUrl";
import {ShareViaEmailForm, useGuideConfig, useNeuroMessages, notifySuccess} from '@ignitesales/neuro-application';
import getGuideId from "../utils/getBranchId.mjs";

/**
 * BRANCH:
 * If this is a branch guide, we will show an iFrame where the user can enter their email
 * and HW will handle the rest
 * ONLINE:
 * If online guide, use our normal ShareViaEmail handler
 **/

const ShareViaEmailModal = ({ active, onClose, products, onEmailComplete }) => {
  const { isBranchGuide, guideType } = useGuideConfig();
  const { formatIntlMessage } = useNeuroMessages();
  const iframeUrl = buildHubspotEmailUrl({
    products,
    guideId: getGuideId({ isBranchGuide, guideType})
  });

  const onCloseClick = () => {
    onClose({
      emailSent: false
    });
  };

  const onEmailSent = () => {
    notifySuccess('shareViaEmail');
    onClose({
      emailSent: true
    });
    onEmailComplete();
  };

  return <Modal
    show={ active }
    className="shareViaEmail"
    title={ formatIntlMessage({ id: 'shareViaEmail.title' }) }
    onClose={ onCloseClick }
    nodeId="root"
    closeBtn={ <i className="ion-ios-close"/> }
  >
    { isBranchGuide
      ? <iframe src={iframeUrl} className="shareViaEmail__iframe" scrolling="yes" />
      : <ShareViaEmailForm onSubmit={ onEmailSent }/>
    }
  </Modal>;
};

export default ShareViaEmailModal;
